$(function () {
	$('#userregistrationform, #login')
		.find('input[type=password]')
		.each(function () {
			var input = $(this);
			var link = $("<a href='#' class='show-password'>Zobrazit heslo</a>").insertAfter(input);
			link.click(function () {
				if (input.attr('type') === 'password') {
					input.attr('type', 'text');
					link.text('Skrýt heslo');
				} else {
					input.attr('type', 'password');
					link.text('Zobrazit heslo');
				}
			});
		});
});
